import { observer } from 'mobx-react-lite';
import React, { useState, useEffect, useRef } from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha'; 

const ForgetPasswordForm = observer(({ cartStore }) => { 
  const password = useRef();
  const cPassword = useRef();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [cPasswordClass, setCPasswordClass] = useState('form-control');
  const [isCPasswordDirty, setIsCPasswordDirty] = useState(false);
  const [token, setToken] = useState('')
  const verifyRecaptchaCallback = React.useCallback((token) => { 
    setToken(token)
  }, []);

  useEffect(() => {
    loadCaptchaEnginge(6);
    if (isCPasswordDirty) {
      if (password.current.value === cPassword.current.value) { 
        setShowErrorMessage(false);
        setCPasswordClass('form-control is-valid')
      } else {
        setShowErrorMessage(true)
        setCPasswordClass('form-control is-invalid')
      }
    }
  }, [isCPasswordDirty])

  const checkPasswords = (e) => {
    setIsCPasswordDirty(true);
    if (isCPasswordDirty) {
      if (password.current.value === cPassword.current.value) {
        setShowErrorMessage(false);
        setCPasswordClass('form-control is-valid')
      } else {
        setShowErrorMessage(true)
        setCPasswordClass('form-control is-invalid')
      }
    }

  }

  const doSubmit = () => {
    let user_captcha = document.getElementById('user_captcha_input').value;
    let email = document.getElementById('register_email').value; 
    let register_firstname = document.getElement


    if (validateCaptcha(user_captcha) == true) {
      alert('Captcha Matched');
      loadCaptchaEnginge(6);
      document.getElementById('user_captcha_input').value = "";
    }

    if(email == "") {
        alert("please add the email address");
    }


    else {
      alert('Captcha Does Not Match');
      document.getElementById('user_captcha_input').value = "";
    }
  };

  console.log("the register form is");
  return (
    <>
      <fieldset>
        <legend><span><h6>Ihr Passwort hier abrufen</h6></span></legend>  
        <span>Gib Deine E-Mail-Adresse ein, um einen Link per E-Mail zu erhalten, mit dem Du Dein Passwort zurücksetzen kannst.</span>
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12">
            <input
              type="email"
              placeholder="E-Mail"
              name="register_email"
              className="form-control" 
              id="register_email"
              onChange={(e) =>
                cartStore.updateRegisterForm('register_email', e.target.value)
              }
              autoComplete="register_email"
            />
          </div>
          <div>
          <div className="col mt-3"> 
            <LoadCanvasTemplate />
          </div>
          <div className="col mt-3">
            <div><input placeholder="Enter Captcha Value" id="user_captcha_input" name="user_captcha_input" type="text"></input></div>
          </div>

          <div className="col mt-3">
            <div><button className="btn btn-primary" onClick={() => doSubmit()}>Submit</button></div> 
          </div>
        </div>
        </div>
      </fieldset> 
    </>
  );
});
export default ForgetPasswordForm;  
